import React from "react";

function Column({ children, size, className= '' }) {
  return <div className={`column size-${size} ${className}`}>{children}</div>;
}

export default Column;
